import React, { createContext, useContext, useState } from 'react';

interface MapState {
  id: number | null;
  setState: React.Dispatch<React.SetStateAction<MapState>>;
}

const defautMapState: MapState = {
  id: null,
  setState: () => {},
};

const MapContext = createContext<MapState>(defautMapState);

export const useMapContext = () => {
  const context = useContext<MapState>(MapContext);

  if (context === undefined) {
    throw new Error('useMapContext must be used within a MapContextProvider');
  }
  return context;
};

export const MapProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const [state, setState] = useState<MapState>(defautMapState);
  return <MapContext.Provider value={{ ...state, setState }}>{children}</MapContext.Provider>;
};
